import React, { useState, useEffect } from 'react';
import { getStates, getCountiesForState } from './FilterHelper';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { TextField, Autocomplete, FormControl } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ColorConstants from '../../../../defaults/ColorConstants';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '100%'
  },
  select: {
    color: ColorConstants.GrayAlien,
    backgroundColor: ColorConstants.WhiteAlien,
    '&.MuiSelect-icon': {
      color: ColorConstants.GrayAlien,
    }
  },
  inputLabel: {
  },
}));

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          //border on focus
          borderColor: ColorConstants.BlueAlien,
          border: '2px solid'
        },
      },
    },
    MuiSelect: {
      icon: {
        color: ColorConstants.GrayAlien
      },
      root: {
        //padding: 16
      }
    },
    MuiInputLabel: {
      root: {
        // fontSize: 14
      }
    }
  },
});

const states = getStates();

export default function StateCountyFilter({setStateValue, stateValue, setCountyValue, countyValue}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [counties, setCounties] = useState([]);

  useEffect(() => {
    let countyList = [];
    stateValue.forEach(element => {
      let countiesBasedOnState = getCountiesForState(element.code);
      countiesBasedOnState.forEach((county) => {
        const obj = {
          name: county,
          code: county
        }
        countyList.push(obj);
      })
    });
    const unique = [...new Map(countyList.map((c) => [c.name, c])).values()];
    setCounties(unique.sort((a, b) => {
      return (a.name < b.name) ? -1 : 1;
    }));
    
}, [stateValue, countyValue]);

useEffect(() => {
  if(counties){
    //Here to cause a reload
  }
}, [counties])

  const handleChangeState = (event, newValue) => {
    dispatch(setStateValue(newValue));
  };

  const handleChangeCounty = (event, newValue) => {
    dispatch(setCountyValue(newValue));
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <div style={{ display: 'flex', flexDirection: 'column'}}>
        <FormControl variant="outlined" className={classes.formControl}>
          <Autocomplete
            multiple={true}
            value={stateValue ? stateValue : []}
            disablePortal
            id="combo-box-demo"
            options={states}
            getOptionLabel={(option) => option.name}
            onChange={(event, newValue) => {
              handleChangeState(event, newValue);
            }}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="State" />}
          />
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <Autocomplete
            multiple={true}
            value={countyValue ? countyValue : []}
            disablePortal
            id="combo-box-demo"
            options={counties}
            getOptionLabel={(option) => option.name}
            onChange={(event, newValue) => {
              handleChangeCounty(event, newValue);
            }}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="County" />}
          />
        </FormControl>
        </div>
      </ThemeProvider>
    </div>
  );
}
